import { api } from "./api";

export class CityService {
  async post(value: string) {
    try {
      const response = await api.post(`/city`, value);
      return response;
    } catch (error: any) {
      return error.response;
    }
  }

  async get() {
    try {
      const response = await api.get(`/city`);
      return response.data.data;
    } catch (error: any) {
      return error.response;
    }
  }

  async getById(id: string) {
    try {
      const response = await api.get(`/city/${id}`);
      return response.data.data;
    } catch (error: any) {
      return error.response;
    }
  }

  async getByStateId(id: string) {
    try {
      const response = await api.get(`/city/state/${id}`)
      return response.data.data;
    } catch (error: any){
      return error.response
    }
  }

  async patch(value: string, id: string) {
    try {
      const response = await api.patch(`/city/${id}`, value);
      return response;
    } catch (error: any) {
      return error.response;
    }
  }

  async delete(id: string) {
    try {
      const response = await api.delete(`/city/${id}`);
      return response;
    } catch (error: any) {
      return error.response;
    }
  }
}
